import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddLab, EditLab, Lab, LabParams, LabWithPage } from '@app/interfaces/rm/location-lab';
import { SelectOption } from '@app/interfaces/sys/dict';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LocationLabService {
    private baseUrl = environment.api.services.rm + '/location-labs';

    constructor(private http: HttpClient) {
    }

    async find(params: LabParams): Promise<LabWithPage> {
        return lastValueFrom(this.http.get<LabWithPage>(`${this.baseUrl}`, {
            params: Object.assign(params),
        }));
    }

    async options(): Promise<SelectOption[]> {
        return lastValueFrom(this.http.get<SelectOption[]>(`${this.baseUrl}/all-options`));
    }

    async add(params: AddLab): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}`, params));
    }

    async edit(data: EditLab): Promise<void> {
        return lastValueFrom(this.http.put<void>(`${this.baseUrl}`, data));
    }

    async remove(id: number): Promise<void> {
        return lastValueFrom(this.http.delete<void>(`${this.baseUrl}`, {
            params: Object.assign({ id }),
        }))
    }
}
